export default __webpack_public_path__ + "static/media/star-like.843f6014.svg";